export const environment = {
  production: true,
  apiUrl: 'http://mis.sci.buu.ac.th/mis/api/',
  // apiUrl: 'http://10.18.0.11/mis/api/',
};
